// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"242":"76f6b9b1","254":"fd0bfb64","451":"5f448b98","508":"a933e2d1","519":"7ad4c869","521":"863f6a45","668":"22ee7538","977":"af77e6d9","981":"2e6ba43c"}[chunkId] + ".js";
};